import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage, GetDayOfWeekName } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Button, Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import Select from '@material-ui/core/Select';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import { TimePicker } from 'antd';
import DeleteIcon from '@material-ui/icons/Delete';
import appFetch from '../../../../api/appFetch.js';
import { MoboOutletOpeningHoursByOutletIdUrl, MoboOutletOpeningHoursWithIdUrl } from '../../../../constants/apiUrls.js';
import { Receipt } from '@material-ui/icons';
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';
import ModifiedByInfo from "./../../../Common/Footers/ModifiedByInfo";

const format = 'HH:mm';

export default class OpeningHoursEditing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openingHourId: parseInt(this.props.openingHourId),
      id: 0,
      outletId: parseInt(this.props.outletId),
      outletName: "",
      workshopOpenFrom: null,
      workshopOpenTill: null,
      workshopDropFrom: null,
      workshopDropTill: null,
      workshopDropCloseNoonFrom: null,
      workshopDropCloseNoonTill: null,
      isWorkshopClosed: false,
      dayOfWeek: "",
      modifiedOn: "",
      modifiedByName: "",
      modifiedByAvatar: "",
      selectedOutletId: 0,
      loading: this.props.editedOpeningHourId !== undefined,
      redirect: false,
      accessibleMoboOutlets: [],
      editedOpeningHourId: this.props.editedOpeningHourId,
      requestInProgress: false,
      open: true,
      openingHourWasModified: false,
      openingHour: [],
      onlineOpenFrom: null,
      onlineOpenTill: null,
      defaultDropTime: null,
      defaultEndOfDayTime: null,
    };
  }

  componentDidMount() {
    this.getOpeningHourById(this.state.openingHourId, this.state.outletId);
  }

  handleClose = () => {
    this.setState({ open: false, redirect: "/openinghours" });
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };


  handleChangeTimetableInput = (value, inputType) => {
    this.setState({ [inputType]: value === '' ? null : value });
  }

  clearTime = (from, till) => {
    this.setState({ [from]: null, [till]: null });
  }

  handleChangeCheckBox = e => {
    this.setState({ [e.target.name]: e.target.checked });
  };

  handleSubmit = () => {
    this.saveEditedOpeningHour();
  }

  getEditegOpeningHourDetails = (editedOpeningHour) => {
    let resources = this.props.resources;
    var dayOfWeekName = GetDayOfWeekName(editedOpeningHour.dayOfWeek, resources);
    this.setState({
      openingHour: editedOpeningHour,
      id: editedOpeningHour.id,
      outletId: editedOpeningHour.moboOutletId,
      workshopOpenFrom: editedOpeningHour.workshopOpenFrom,
      workshopOpenTill: editedOpeningHour.workshopOpenTill,
      workshopDropFrom: editedOpeningHour.workshopDropFrom,
      workshopDropTill: editedOpeningHour.workshopDropTill,
      workshopDropCloseNoonFrom: editedOpeningHour.workshopDropCloseNoonFrom,
      workshopDropCloseNoonTill: editedOpeningHour.workshopDropCloseNoonTill,
      isWorkshopClosed: editedOpeningHour.isWorkshopClosed,
      dayOfWeek: dayOfWeekName,
      loading: false,
      modifiedOn: editedOpeningHour.updatedBy !== null ? editedOpeningHour.updatedOn : editedOpeningHour.createdOn,
      modifiedByName: editedOpeningHour.updatedBy !== null ? editedOpeningHour.updatedBy.firstName + " " + editedOpeningHour.updatedBy.lastName : editedOpeningHour.createdBy.firstName + " " + editedOpeningHour.createdBy.lastName,
      modifiedByAvatar: editedOpeningHour.updatedBy != null ? editedOpeningHour.updatedBy.avatar : editedOpeningHour.createdBy.avatar,
      onlineOpenFrom: editedOpeningHour.onlineOpenFrom,
      onlineOpenTill: editedOpeningHour.onlineOpenTill
    });
  }

  isValidForm = () => {
    const { workshopOpenFrom, workshopOpenTill, workshopDropFrom, workshopDropTill, isWorkshopClosed } = this.state;

    if (isWorkshopClosed) {
      return true;
    }

    if (!workshopOpenFrom) {
      return false;
    }

    if (!workshopOpenTill) {
      return false;
    }

    if (!workshopDropFrom) {
      return false;
    }

    if (!workshopDropTill) {
      return false;
    }

    return true;
  }

  getOpeningHourById = (openingHourId) => {
    this.setState({ requestInProgress: true });
    let resources = this.props.resources;
    const url = MoboOutletOpeningHoursWithIdUrl(openingHourId);

    appFetch({
      url: url,
      onSuccess: (rowData) => {
        var dayOfWeekName = GetDayOfWeekName(rowData.dayOfWeek, resources);

        this.setState({
          openingHour: rowData,
          id: rowData.id,
          outletId: rowData.moboOutletId,
          workshopOpenFrom: rowData.workshopOpenFrom,
          workshopOpenTill: rowData.workshopOpenTill,
          workshopDropFrom: rowData.workshopDropFrom,
          workshopDropTill: rowData.workshopDropTill,
          workshopDropCloseNoonFrom: rowData.workshopDropCloseNoonFrom,
          workshopDropCloseNoonTill: rowData.workshopDropCloseNoonTill,
          isWorkshopClosed: rowData.isWorkshopClosed,
          dayOfWeek: dayOfWeekName,
          loading: false,
          modifiedOn: rowData.updatedBy !== null ? rowData.updatedOn : rowData.createdOn,
          modifiedByName: rowData.updatedBy !== null ? rowData.updatedBy.firstName + " " + rowData.updatedBy.lastName : rowData.createdBy.firstName + " " + rowData.createdBy.lastName,
          modifiedByAvatar: rowData.updatedBy != null ? rowData.updatedBy.avatar : rowData.createdBy.avatar,
          onlineOpenFrom: rowData.onlineOpenFrom,
          onlineOpenTill: rowData.onlineOpenTill,
          defaultDropTime: rowData.defaultDropTime,
          defaultEndOfDayTime: rowData.defaultEndOfDayTime
        });

      },
      onError: (data) => {
        for (let i = 0; i < data.errors.length; i++) {
          DisplayMessage(data.errors[i], "error");
        }
      },
      onFinalize: () => {
        this.setState({ requestInProgress: false });
      }
    })
  }

  saveEditedOpeningHour = () => {
    let resources = this.props.resources;

    const { openingHour, openingHourId, workshopOpenFrom, workshopOpenTill, workshopDropFrom, workshopDropTill, workshopDropCloseNoonFrom,
      workshopDropCloseNoonTill, isWorkshopClosed, dayOfWeek, onlineOpenFrom, onlineOpenTill,
      defaultDropTime, defaultEndOfDayTime } = this.state;

    if (isWorkshopClosed === false && (workshopOpenFrom === null || workshopOpenTill == null || workshopOpenFrom > workshopOpenTill)) {
      DisplayMessage(resources["InvalidWorkshopOpenTimeInterval"], "error");
      return;
    }

    if (isWorkshopClosed === false && (workshopDropFrom === null || workshopDropTill == null || workshopDropFrom > workshopDropTill)) {
      DisplayMessage(resources["InvalidWorkshopDropTimeInterval"], "error");
      return;
    }

    if (isWorkshopClosed === false && (workshopDropCloseNoonFrom !== null && workshopDropCloseNoonTill !== null && workshopDropCloseNoonFrom > workshopDropCloseNoonTill)) {
      DisplayMessage(resources["InvalidWorkshopOpenTimeInterval"], "error");
      return;
    }
    if (isWorkshopClosed === false && (onlineOpenFrom !== null && onlineOpenTill !== null && onlineOpenFrom > onlineOpenTill)) {
      DisplayMessage(resources["InvalidOnlineOpenTimeInterval"], "error");
      return;
    }

    this.setState({ requestInProgress: true });

    var json = JSON.stringify({
      workshopOpenFrom: workshopOpenFrom === null ? "08:00" : workshopOpenFrom,
      workshopOpenTill: workshopOpenTill === null ? "17:00" : workshopOpenTill,
      workshopDropFrom: workshopDropFrom === null ? "08:00" : workshopDropFrom,
      workshopDropTill: workshopDropTill === null ? "16:00" : workshopDropTill,
      workshopDropCloseNoonFrom: workshopDropCloseNoonFrom,
      workshopDropCloseNoonTill: workshopDropCloseNoonTill,
      isWorkshopClosed: isWorkshopClosed,
      onlineOpenFrom: onlineOpenFrom,
      onlineOpenTill: onlineOpenTill,
      defaultDropTime: defaultDropTime,
      defaultEndOfDayTime: defaultEndOfDayTime
    });

    const url = MoboOutletOpeningHoursByOutletIdUrl(openingHourId);

    appFetch({
      url: url,
      method: 'PUT',
      body: json,
      onSuccess: (data) => {
        if (data.id !== undefined) {
          this.setState({
            updateInProgress: false,
            openingHourWasModified: true,
            redirect: "/openinghours"
          });

          DisplayMessage(resources["OpeningHourWasSaved"], "success");
        }
      },
      onError: (data) => {
        for (let i = 0; i < data.errors.length; i++) {
          DisplayMessage(data.errors[i], "error");
        }
      },
      onFinalize: () => {
        this.setState({ requestInProgress: false });
      }
    })
  }

  renderModifiedByInfo = () => {
    if (this.state.id > 0 && this.state.modifiedOn !== null) {
      return (
        <ModifiedByInfo
          resources={this.props.resources}
          modifiedByAvatar={this.state.modifiedByAvatar}
          modifiedOn={this.state.modifiedOn}
          modifiedByName={this.state.modifiedByName}
          className="mt-3"
        />
      );
    }
    return;
  }

  renderTimeIntervalRow = ({ label, fromValue, fromName, tillValue, tillName, mandatory, deleteButtonId }) => {
    return (
      <React.Fragment>
        <Grid item xs={2} />
        <Grid item xs={3} style={{ textAlign: "left" }}>
          <Typography variant="subtitle1">{this.props.resources[label]}<span className="validation-red">{mandatory && <span> *</span>}</span></Typography>
        </Grid>
        <Grid item xs={2}>
          {fromName && <TimePicker id={fromName} minuteStep={5} placeholder={this.props.resources["SelectTime"]} format={format} name={fromName} value={fromValue !== null ? moment(fromValue, format) : null} onChange={(time, timeString) => this.handleChangeTimetableInput(timeString, fromName)} />}
        </Grid>
        <Grid item xs={2}>
          {tillName && <TimePicker id={tillName} minuteStep={5} placeholder={this.props.resources["SelectTime"]} format={format} name={tillName} value={tillValue !== null ? moment(tillValue, format) : null} onChange={(time, timeString) => this.handleChangeTimetableInput(timeString, tillName)} />}
        </Grid>
        <Grid item xs={1} style={{ textAlign: "right" }}>
          <IconButton id={deleteButtonId} size="small"><DeleteIcon onClick={() => this.clearTime(fromName ?? tillName, tillName ?? fromName)} color="primary" /></IconButton>
        </Grid>
        <Grid item xs={2} />
      </React.Fragment>
    )
  }

  renderForm() {
    const { workshopOpenFrom, workshopOpenTill, workshopDropFrom, workshopDropTill, workshopDropCloseNoonFrom, workshopDropCloseNoonTill, isWorkshopClosed,
      dayOfWeek, onlineOpenFrom, onlineOpenTill, defaultDropTime, defaultEndOfDayTime } = this.state;

    var resources = this.props.resources;
    var displayTimetable = isWorkshopClosed ? "none" : "flex";

    return (
      <Paper elevation={3} className="p-4 mt-3 mb-3">
        <Form>
          <Grid container spacing={2} className="mb-6">
            <Grid container spacing={2} className="mb-6" style={{ marginBottom: "5px" }}>
              <React.Fragment>
                <Grid item xs={2} />
                <Grid item xs={8} >
                  <OutletsDropdown
                    resources={resources}
                    outlets={this.props.accessibleMoboOutlets}
                    outlet={this.state.outletId}
                    onOutletChange={this.handleChangeOutlet}
                    containerClass="helper-text-red"
                    disabled
                  />
                </Grid>
                <Grid item xs={2} />
              </React.Fragment>

              <React.Fragment>
                <Grid item xs={2} />
                <Grid item xs={8}>
                  <ThemeProvider theme={SelectTheme}>
                    <TextField style={{ width: "100%" }} disabled={true} id="openinghours-dayOfWeek" value={dayOfWeek} label={resources["DayOfWeek"]}
                      variant="outlined" name="dayOfWeek" onChange={this.handleChange} inputProps={{ maxLength: 100 }} />
                  </ThemeProvider>
                </Grid>
                <Grid item xs={2} />
              </React.Fragment>

              <React.Fragment>
                <Grid item xs={2} />
                <Grid item xs={8}>
                  <FormControlLabel style={{ width: "100%" }} className="text-right label-mt my-auto p-0"
                    control={<Checkbox id="openinghours-is-active" checked={isWorkshopClosed} onChange={this.handleChangeCheckBox} name="isWorkshopClosed" color="primary" />}
                    label={resources["IsWorkshopClosed"]} />
                </Grid>
                <Grid item xs={2} />
              </React.Fragment>
            </Grid>

            <Grid container style={{ display: displayTimetable }}>
              <React.Fragment>
                <Grid item xs={2} />
                <Grid item xs={8} >
                  <hr className="MuiDivider-root" />
                </Grid>
                <Grid item xs={2} />
              </React.Fragment>

              <Grid container spacing={2} className="mb-6" style={{ display: displayTimetable, marginTop: "10px", marginBottom: "10px" }}>
                <React.Fragment>
                  <Grid item xs={5} />
                  <Grid item xs={2}>
                    <Typography variant="caption" display="block">{resources["From"]}<span > </span></Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography variant="caption" display="block">{resources["Till"]}<span > </span></Typography>
                  </Grid>
                  <Grid item xs={3} />
                </React.Fragment>

                {[
                  { label: "WorkshopOpen", fromValue: workshopOpenFrom, fromName: "workshopOpenFrom", tillValue: workshopOpenTill, tillName: "workshopOpenTill", mandatory: true, deleteButtonId: "workshopOpenDelete" },
                  { label: "WorkshopDrop", fromValue: workshopDropFrom, fromName: "workshopDropFrom", tillValue: workshopDropTill, tillName: "workshopDropTill", mandatory: true, deleteButtonId: "workshopDropDelete" },
                  { label: "WorkshopDropCloseNoon", fromValue: workshopDropCloseNoonFrom, fromName: "workshopDropCloseNoonFrom", tillValue: workshopDropCloseNoonTill, tillName: "workshopDropCloseNoonTill", deleteButtonId: "workshopDropCloseNoonDelete" },
                  { label: "OnlineOpen", fromValue: onlineOpenFrom, fromName: "onlineOpenFrom", tillValue: onlineOpenTill, tillName: "onlineOpenTill", deleteButtonId: "onlineOpenDelete" }
                ].map((rowInfo, index) => <React.Fragment key={`time-interval-${index}`}>{this.renderTimeIntervalRow(rowInfo)}</React.Fragment>)}
              </Grid>

              <React.Fragment>
                <Grid item xs={2} />
                <Grid item xs={8}>
                  <hr className="MuiDivider-root" />
                </Grid>
                <Grid item xs={2} />
              </React.Fragment>

              <Grid container spacing={2} className="mb-6" style={{ marginTop: "10px", marginBottom: "10px" }}>
                {[
                  { label: "DefaultDropTime", fromValue: defaultDropTime, fromName: "defaultDropTime", deleteButtonId: "defaultDropTimeDelete" },
                  { label: "DefaultEndOfDayTime", fromValue: defaultEndOfDayTime, fromName: "defaultEndOfDayTime", deleteButtonId: "defaultEndOfDayTimeDelete" }
                ].map((rowInfo, index) => <React.Fragment key={`default-time-${index}`}>{this.renderTimeIntervalRow(rowInfo)}</React.Fragment>)}
              </Grid>
            </Grid>
          </Grid>
          {this.renderModifiedByInfo()}
        </Form>
      </Paper>
    );
  }

  renderMain() {
    const { loading } = this.state;

    if (loading) {
      return (<div className="centered-loader"><CircularProgress /></div>);
    }

    return (<div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
      {this.renderForm()}
    </div>);
  }

  render() {
    const { redirect, open, openingHourWasModified, outletId, requestInProgress } = this.state;
    const { resources } = this.props;

    const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect

    return (
      <div>
        {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: openingHourWasModified, outletId } }} delay={250} />}
        <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
          <AppBar className="position-sticky">
            <Toolbar>
              <IconButton id="close-edit-OpeningHour" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" style={{ flex: 1 }}>
                {resources["EditOpeningHour"]}
              </Typography>
              <Button id="openinghours-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSubmit}>{resources["Save"]}</Button>
            </Toolbar>
          </AppBar>
          <div className="container">
            {this.renderMain()}
          </div>
        </Dialog>
      </div >
    );
  }
}